import React, { useState, useEffect } from 'react';
import { Search, MessageCircle, UserPlus } from 'lucide-react';
import useAxiosInstance from '../../../lib/useAxiosInstance';
import { useQuery, useQueryClient } from 'react-query';


export const MessageSidebar = ({
  chats,
  selectedChatId,
  onChatSelect,
  searchTerm,
  onSearchChange,
  onAddContact,
}) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const axiosInstance = useAxiosInstance();
    const queryClient = useQueryClient();
    const [contacts, setContacts] = useState([]);
    const [showContacts, setShowContacts] = useState(false);

    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        
        if (days === 0) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        } else if (days === 1) {
        return 'Yesterday';
        } else if (days < 7) {
        return date.toLocaleDateString([], { weekday: 'short' });
        } else {
        return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
        }
    };

    const fetchUsers = async ({ searchTerm = "", page = 1, limit = 20 }) => {
        let url = "";
            url = `/api/directory/users`;
            const res = await axiosInstance.get(url);
            const all = res?.data?.data?.results?.map(u => ({ ...u, type: "user" })) || [];
            return {
            results: all,
            total: res?.data?.data?.totalUsers || all.length,
            
        }
    };

    const { data, isLoading, isError } = useQuery(
        ["contacts"],
        fetchUsers,
        { keepPreviousData: true, refetchOnWindowFocus: false }
      );
      const users = data?.results || [];
      const total = data?.total || 0;
    return (
        <div className="w-80 border-r border-gray-200 flex flex-col">
        {/* Header */}
        <div className="!p-4 border-b border-gray-200 card-wrapper !rounded-none">
            <div className='flex justify-between items-center'>
              <h2 className="text-lg font-semibold text-gray-900 ">Messages</h2>
              <button
                  onClick={() => setShowContacts(!showContacts)}
                  className="p-1 rounded-full hover:bg-gray-100"
                  title="Add Contact"
              >
                  <UserPlus className="w-5 h-5 text-blue-600" />
              </button>
            </div>

            {/* Search */}
            <div className="relative mt-4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
                type="text"
                placeholder="Search conversations..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 card-wrapper"
            />
            </div>
            
        </div>


        {/* Contacts dropdown */}
      {showContacts && (
        <div className="max-h-60 overflow-y-auto border-b border-gray-200">
          {users?.map((user) => (
            <div
              key={user._id}
              onClick={() => {
                onAddContact(user);
                setShowContacts(false);
              }}
              className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100"
            >
              {user.firstName + " " + user.lastName || user.email}
            </div>
          ))}
        </div>
      )}
        {/* Chat List */}
        <div className="flex-1 overflow-y-auto">
            {chats.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-64 text-gray-500">
                <MessageCircle className="w-12 h-12 mb-2" />
                <p>No conversations found</p>
            </div>
            ) : (
            chats?.map((chat) => (
                <div
                key={chat?._id}
                onClick={() => onChatSelect(chat?._id)}
                className={`flex items-center space-x-3 p-4 hover:bg-gray-50 cursor-pointer border-b border-gray-100 ${
                    selectedChatId === chat?._id ? 'bg-blue-50 border-r-2 border-r-blue-500' : ''
                }`}
                >
                <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-medium overflow-hidden">
                {chat?.isGroup ? (
                  chat?.groupIconUrl ? (
                    <img
                      src={chat.groupIconUrl}
                      alt="group"
                      className="w-12 h-12 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-12 h-12 bg-gradient-to-br from-[#004877] to-purple-200 rounded-full flex items-center justify-center text-white font-medium">
                      {chat?.name
                        ? chat.name
                            .split(" ")
                            .map((n) => n[0])
                            .join("")
                            .toUpperCase()
                        : "?"}
                    </div>
                  )
                  ) : (() => {
                      const otherUser = chat?.participants?.find(
                        (p) => p.user?._id !== user?._id
                      )?.user;
                      if (!otherUser) return (
                        <div className="w-12 h-12 bg-gray-400 rounded-full flex items-center justify-center">?</div>
                      );

                      return otherUser.profileImageLink ? (
                        <img
                          src={otherUser.profileImageLink}
                          alt="user"
                          className="w-12 h-12 rounded-full object-cover"
                        />
                      ) : (
                        <div className="w-12 h-12 bg-gradient-to-br from-[#004877] to-purple-200 rounded-full flex items-center justify-center text-white font-medium">
                          {otherUser.firstName || otherUser.lastName
                            ? `${otherUser.firstName?.[0] || ""}${otherUser.lastName?.[0] || ""}`.toUpperCase()
                            : otherUser.email
                            ? otherUser.email[0].toUpperCase()
                            : "?"}
                        </div>
                      );
                    })()}
              </div>
                
                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                    <h3 className="font-medium text-gray-900 truncate">
                      {chat?.isGroup
                        ? chat?.name
                        : (() => {
                            const otherUser = chat?.participants?.find(
                              (p) => p.user?._id !== user?._id
                            )?.user;

                            return otherUser
                              ? `${otherUser.firstName || ""} ${otherUser.lastName || ""}`.trim()
                              : "Unknown User";
                          })()}
                    </h3>
                    <span className="text-xs text-gray-500">
                      {chat?.lastMessageTime 
                        ? formatTime(chat?.lastMessageTime) 
                        : formatTime(chat?.lastMessage?.createdAt)}
                    </span>
                    </div>
                    
                    <div className="flex items-center justify-between">
                    {/* <p className="text-sm text-gray-600 truncate">{chat?.data?.lastMessage}</p> */}
                    {chat.unreadCount > 0 && (
                        <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full ml-2">
                        {chat?.unreadCount}
                        </span>
                    )}
                    </div>
                </div>
                </div>
            ))
            )}
        </div>
        </div>
    );
    };
